import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth.guard';
import { IncomeGuard } from './core/income.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'health',
    canActivate: [AuthGuard],
    loadChildren: () => import('./health/health.routes').then(r => r.healthRoutes)
  },
  {
    path: 'servers',
    canActivate: [AuthGuard],
    loadChildren: () => import('./server-monitor/server-monitor.routes').then(r => r.serverMonitorRoutes)
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(c => c.LoginComponent)
  },
  {
    path: 'course',
    canActivate: [AuthGuard],
    loadChildren: () => import('./course/course.routes').then(r => r.courseRoutes)
  },
  {
    path: 'log',
    canActivate: [AuthGuard],
    loadChildren: () => import('./log/log.routes').then(r => r.logRoutes)
  },
  {
    path: 'setting',
    canActivate: [AuthGuard],
    loadChildren: () => import('./setting/setting.routes').then(r => r.settingRoutes)
  },
  {
    path: 'observer',
    canActivate: [AuthGuard, IncomeGuard],
    loadChildren: () => import('./observer/observer.routes').then(r => r.observerRoutes)
  },
  {
    path: 'income',
    canActivate: [AuthGuard, IncomeGuard],
    loadChildren: () => import('./income/income.routes').then(r => r.incomeRoutes)
  },
  {
    path: 'page',
    canActivate: [AuthGuard],
    loadChildren: () => import('./page/page.routes').then(r => r.pageRoutes)
  },
  {
    path: 'news',
    canActivate: [AuthGuard],
    loadChildren: () => import('./news/news.routes').then(r => r.newsRoutes)
  },
  {
    path: 'faq',
    canActivate: [AuthGuard],
    loadChildren: () => import('./faq/faq.routes').then(r => r.faqRoutes)
  },
  {
    path: 'promo',
    canActivate: [AuthGuard],
    loadChildren: () => import('./promo/promo.routes').then(r => r.promoRoutes)
  },
  {
    path: 'category',
    canActivate: [AuthGuard],
    loadChildren: () => import('./category/category.routes').then(r => r.categoryRoutes)
  },
  {
    path: 'topic',
    canActivate: [AuthGuard],
    loadChildren: () => import('./topic/topic.routes').then(r => r.topicRoutes)
  },
  {
    path: 'source',
    canActivate: [AuthGuard],
    loadChildren: () => import('./source/source.routes').then(r => r.sourceRoutes)
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.routes').then(r => r.userRoutes)
  },
  {
    path: 'downloads',
    canActivate: [AuthGuard],
    loadChildren: () => import('./downloads/downloads.routes').then(r => r.downloadsRoutes)
  },
  {
    path: 'comment',
    canActivate: [AuthGuard],
    loadChildren: () => import('./comment/comment.routes').then(r => r.commentRoutes)
  },
  {
    path: 'mail',
    canActivate: [AuthGuard],
    loadChildren: () => import('./mail/mail.routes').then(r => r.mailRoutes)
  },
  {
    path: 'mass',
    canActivate: [AuthGuard],
    loadChildren: () => import('./mass/mass.routes').then(r => r.massRoutes)
  },
  {
    // Generic reader for whitelisted cron logs (mass-mail,
    // system-notification, parse-mail, stripe-checker, publish-news,
    // …). Backend endpoints: /cron-log (catalog) + /cron-log/{name}.
    // The frontend route is /cron-log too for symmetry — /admin-log
    // is taken on the backend by AdminLogController::getLists (admin
    // action history); collisions there 500 the whole API.
    path: 'cron-log',
    canActivate: [AuthGuard],
    loadChildren: () => import('./admin-log/admin-log.routes').then(r => r.adminLogRoutes)
  },
  {
    path: 'system-message',
    canActivate: [AuthGuard],
    loadChildren: () => import('./system-message/system-message.routes').then(r => r.systemMessageRoutes)
  },
  {
    path: 'push-subscriptions',
    canActivate: [AuthGuard],
    loadChildren: () => import('./push-subscriptions/push-subscriptions.routes').then(r => r.pushSubscriptionsRoutes)
  },
  {
    path: 'order',
    canActivate: [AuthGuard],
    loadChildren: () => import('./order/order.routes').then(r => r.orderRoutes)
  },
  {
    path: 'navigation',
    canActivate: [AuthGuard],
    loadChildren: () => import('./navigation/navigation.routes').then(r => r.navigationRoutes)
  },
  {
    path: 'package',
    canActivate: [AuthGuard],
    loadChildren: () => import('./package/package.routes').then(r => r.packageRoutes)
  },
  {
    path: 'skladchina',
    canActivate: [AuthGuard],
    loadChildren: () => import('./skladchina/skladchina.routes').then(r => r.skladchinaRoutes)
  },
  {
    path: 'qa',
    canActivate: [AuthGuard],
    loadChildren: () => import('./qa/qa.routes').then(r => r.qaRoutes)
  },
  {
    path: 'vpn',
    canActivate: [AuthGuard],
    loadChildren: () => import('./vpn/vpn.routes').then(r => r.vpnRoutes)
  },
  {
    path: 'feedback',
    canActivate: [AuthGuard],
    loadChildren: () => import('./feedback/feedback.routes').then(r => r.feedbackRoutes)
  },
  {
    path: 'support',
    canActivate: [AuthGuard],
    loadChildren: () => import('./support/support.routes').then(r => r.supportRoutes)
  },
  {
    path: 'kanban',
    canActivate: [AuthGuard],
    loadChildren: () => import('./kanban/kanban.routes').then(r => r.kanbanRoutes)
  }
];